import axios from "axios";

/**
 * Resolve the backend base URL.
 * - Prefer the env var (REACT_APP_BACKEND_URL) when its origin matches the current page's origin.
 * - If the env var points to a different host than where the page is served from
 *   (e.g. an Emergent build baked with the preview/host URL but now served from a
 *   custom domain), fall back to the current origin. The Kubernetes ingress routes
 *   /api/* to the backend on whichever hostname is in use, so this just works.
 * - On the server (SSR / tests), fall back to the env var.
 */
function resolveBackendUrl() {
  const envUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
  if (typeof window === "undefined" || !window.location) return envUrl;
  const pageOrigin = window.location.origin;
  if (!envUrl) return pageOrigin;
  try {
    const envOrigin = new URL(envUrl).origin;
    return envOrigin === pageOrigin ? envUrl : pageOrigin;
  } catch {
    return pageOrigin;
  }
}

const BACKEND_URL = resolveBackendUrl();
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token as fallback (if cookie blocked)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dt_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
